export const faqQuestionsAnswers = [
    {
        id: 1,
        question: 'What is a Restaurant Management System (RMS)?',
        answer: 'Restaurant Management System (RMS) allows you to add and modify products as well as manage the database from the level of a web browser. It also allows you to change the API server.'
    },
    {
        id: 2,
        question: 'For what purpose was the project created?',
        answer: 'The project was designed to create a live demo that allows you to connect to a selected API server with a database of restaurant products and manage them.'
    },
    {
        id: 3,
        question: 'What is the correct JSON format supported by the system?',
        answer: 'The format supported by the Restaurant Management System (RMS) looks as shown. All fields are required depending on the type provided. The schema shows sample data with the data type.'
    },
    {
        id: 4,
        question: 'What HTTP queries does the system support?',
        answer: 'The HTTP queries handled by the Restaurant Management System (RMS) look as shown. '
    }
];
